import React from 'react';

import { Header, Footer, ScrollTop, ScrollToTop } from './components';
import { HomePage, AboutUs, TestimonialsPage, BlogGrid, BlogList, BlogSingle, ShopGrid, ShopList, Contact, ProductSingle, ServiceSingle, ServicePage, FaqPage, PricingPage, ProcessPage, QuotePage, Error404, TermServices, PrivacyPolicy, RefundPolicy } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';



const App = () => {

  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        {/* <Route path='/Why-Choose-Us' element={<WhyUsPage />} /> */}
        <Route path='/Testimonials' element={<TestimonialsPage />} /> 
        <Route path='/Faqs' element={<FaqPage />} />

        {/*Pages*/}
        <Route path='/Get-Quote' element={<QuotePage />} />
        <Route path='/Pricing' element={<PricingPage />} />
        <Route path='/Process' element={<ProcessPage />} />

        <Route path='*' element={<Error404 />} />
        <Route path='/Services-Terms' element={<TermServices />} />
        <Route path='/Refund-Policy' element={<RefundPolicy />} />
        <Route path='/Privacy-Policy' element={<PrivacyPolicy />} />
        
        {/* <Route path='/Help-Center' element={<HelpCenter />} /> */}

        {/*Services*/}
        <Route path='/Services' element={<ServicePage />} />
        <Route path='/Services/:id' element={<ServiceSingle />} />
        <Route path='/Services/Service-Single' element={<ServiceSingle />} />

        {/*Blogs*/}
        <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogGrid />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogGrid />} /> 
        <Route path='/Blogs/search/:search' element={<BlogGrid />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />

        {/*Shop*/}
        <Route path='/Website-Templates' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopGrid />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopGrid />} /> 
        <Route path='/Shop/search/:search' element={<ShopGrid />} /> 
        <Route path='/Website-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 

        {/*Contact*/}
        <Route path='/Contact-us' element={<Contact />} /> 

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      <ToastContainer />
      
    </div>

  )
}

export default App;
